import React, { useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./../../../../../../../../assets/css/Dashboard/Claim.scss";
import CPCSIcon from "../../../../../ServicesIcons/nhs.svg";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { showError } from "../../../../../../../../components/ToastedMessage/ToastedMessage";
import {
  getAnalyticsServicesCompletedClaimed,
  getAnalyticsServicesCompletedToBeClaimed,
  getAnalyticsServicesDeclined,
  updateClaimStatus,
} from "../../../../../../../../dispatchers/pharmacyServiceDispatchers";
import useTitanApp from "../../../../../../../../hooks/useTitanApp";
import OrbitCheckFilter from "./OrbitCheckFilter";
import CustomOrbitCheckFilter from "./CustomOrbitCheckFilter";
import ToBeClaimedSkeletonLoader from "./TobeClaimedSkeletonLoader";

export default function HistoryTobeClaimed(props) {
  const filteredServices = React.useMemo(() => {
    let updatedFilteredServices = props.unclaimedServices;
    if (props.filterType === "3") {
      updatedFilteredServices = updatedFilteredServices.filter(
        (service) => service.status !== 3,
      );
    }
    return updatedFilteredServices;
  }, [props.unclaimedServices, props.filterType]);
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const [rowData, setRowData] = useState([]);

  const PatientColumns = [
    {
      field: "selected",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      onCheckboxValueChanged: onCheckboxValueChanged,
      width: 50,
      selected: false,
    },
    {
      headerName: "Patient name",
      field: "name",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Telephone Number",
      field: "telephoneNumber",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Date of Birth",
      field: "dob",
      sortable: true,
      editable: false,
      selected: false,
      valueFormatter: (params) => {
        if (params.value && params.value !== "0001-01-01T00:00:00Z") {
          const date = new Date(params.value);
          return date.toLocaleDateString("en-GB");
        } else {
          return "-";
        }
      },
      filterValueGetter: (params) => {
        if (params.data?.dob && params.data.dob !== "0001-01-01T00:00:00Z") {
          return new Date(params.data.dob).toLocaleDateString("en-GB");
        }
        return "-";
      },
    },
    {
      headerName: "Service Name",
      field: "serviceName",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Drug Name",
      field: "drugName",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Completed By",
      field: "completedBy",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Engagement Date",
      field: "engagementDate",
      sortable: true,
      editable: false,
      selected: false,
      valueFormatter: (params) => {
        if (params.value !== null) {
          const date = new Date(params.value);
          const options = { day: "2-digit", month: "2-digit", year: "numeric" };
          return date.toLocaleDateString("en-GB", options);
        } else {
          return "-";
        }
      },
    },
    {
      headerName: "Intervention Date",
      field: "interventionDate",
      sortable: true,
      editable: false,
      selected: false,
      valueFormatter: (params) => {
        if (params.value !== null) {
          const date = new Date(params.value);
          const options = { day: "2-digit", month: "2-digit", year: "numeric" };
          return date.toLocaleDateString("en-GB", options);
        } else {
          return "-";
        }
      },
    },
    {
      headerName: "FollowUp Date",
      field: "followUpDate",
      sortable: true,
      editable: false,
      selected: false,
      valueFormatter: (params) => {
        if (params.value !== null) {
          const date = new Date(params.value);
          const options = { day: "2-digit", month: "2-digit", year: "numeric" };
          return date.toLocaleDateString("en-GB", options);
        } else {
          return "-";
        }
      },
    },
    {
      headerName: "Follow-up Status",
      field: "status",
      sortable: true,
      editable: false,
      selected: false,
      valueFormatter: (params) => {
        const statusMap = {
          0: "Pending",
          1: "Progress",
          2: "Completed",
          3: "Decline",
        };

        return statusMap[params.value] ?? "-";
      },
    },
    {
      headerName: "NHS Number",
      field: "nhsNumber",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Address",
      field: "address",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Orbit",
      field: "sendToOrbit",
      filter: OrbitCheckFilter,
      floatingFilter: true,
      floatingFilterComponent: CustomOrbitCheckFilter,
      width: 130,
      cellRenderer: (params) => {
        if (params?.value) {
          return (
            <div
              className={`orbit-badge ${
                params?.data?.sendToOrbit ? "with-tag" : "without-tag"
              }`}
            >
              {params?.data?.sendToOrbit && (
                <span className="listview-due-tag">Orbit</span>
              )}
            </div>
          );
        } else {
          return null;
        }
      },
    },
  ].map((col) => {
    if (
      col.field &&
      !col.valueFormatter &&
      !col.cellRenderer &&
      col.field !== "selected"
    ) {
      return {
        ...col,
        valueFormatter: (params) =>
          params.value === null ||
          params.value === undefined ||
          params.value === ""
            ? "-"
            : params.value,
      };
    }
    return col;
  });

  const { appState, pharmacyServiceState } = useTitanApp();
  const { currentPharmacyId } = appState || {};
  const { currentServiceId, isPharmacyServiceCompletedTobeClaimedLoading } =
    pharmacyServiceState || {};

  function onCheckboxValueChanged(params) {
    const selectedNodes = params?.api?.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node?.data);
    const updatedData = selectedData?.map((item) => item?._id);
    setRowData(updatedData);
  }
  const gridOptions = {
    suppressMovableColumns: true,
    getRowClass: (params) => (params.node.isSelected ? "selected-row" : ""),
    onRowClicked: (event) => {
      if (props.onRowClick) {
        props.onRowClick(event.data);
      }
    },
  };
  const exportToCSV = (apiData, fileName) => {
    const modifiedData = apiData?.map((item) => {
      const statusMap = {
        0: "Pending",
        1: "Progress",
        2: "Completed",
        3: "Decline",
      };

      return {
        "Patient Name": item.name || "-",
        "Telephone Number": item.telephoneNumber || "-",
        "Date of Birth": item.dob
          ? new Date(item.dob).toLocaleDateString("en-GB")
          : "-",
        "Service Name": item.serviceName || "-",
        "Drug Name": item.drugName || "-",
        "Completed By": item.completedBy || "-",
        "Engagement Date": item.engagementDate
          ? new Date(item.engagementDate).toLocaleDateString("en-GB")
          : "-",
        "Intervention Date": item.interventionDate
          ? new Date(item.interventionDate).toLocaleDateString("en-GB")
          : "-",
        "Follow-up Date": item.followUpDate
          ? new Date(item.followUpDate).toLocaleDateString("en-GB")
          : "-",
        "Follow-up Status": statusMap[item.status] ?? "-",
        "NHS Number": item.nhsNumber || "-",
        Address: item.address || "-",
        "Send To Orbit": item.sendToOrbit ? "Yes" : "No",
      };
    });

    const ws = XLSX.utils.json_to_sheet(modifiedData);
    const wb = {
      Sheets: { ["To be Claimed"]: ws },
      SheetNames: ["To be Claimed"],
    };
    const csv = XLSX.utils.sheet_to_csv(ws);
    const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(csvData, `${fileName}.csv`);
    // const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    // const data = new Blob([excelBuffer], { type: fileType });
    // FileSaver.saveAs(data, fileName + fileExtension);
  };

  function sentClaim() {
    updateClaimStatus(rowData).then((data) => {
      if (data) {
        getAnalyticsServicesCompletedClaimed(
          currentPharmacyId,
          currentServiceId,
        );
        getAnalyticsServicesCompletedToBeClaimed(
          currentPharmacyId,
          currentServiceId,
          "1",
        );
        getAnalyticsServicesDeclined(currentPharmacyId, currentServiceId);
      } else {
        showError("Error sending to claim", true, false);
      }
    });
  }

  return (
    <div
      className={`${
        props.darkMode === true ? "ag-theme-alpine-dark" : "ag-theme-alpine"
      }`}
    >
      {isPharmacyServiceCompletedTobeClaimedLoading ? (
        <ToBeClaimedSkeletonLoader />
      ) : props?.unclaimedServices?.length !== 0 ? (
        <>
          <div
            style={{
              height: "500px",
            }}
          >
            <AgGridReact
              rowData={filteredServices}
              columnDefs={PatientColumns}
              gridOptions={gridOptions}
              onSelectionChanged={onCheckboxValueChanged}
              rowSelection="multiple"
              suppressRowTransform={true}
              suppressServerSideFullWidthLoadingRow={true}
              reactiveCustomComponents
            />
          </div>
          <div className="analytics_tab_list_footer">
            {rowData?.length > 0 && (
              <button onClick={sentClaim}>
                <span>Mark as claimed</span>
                <span>
                  <CPCSIcon />
                </span>
              </button>
            )}
            <button
              onClick={(e) => exportToCSV(filteredServices, "ToBeClaimedFile")}
            >
              <p>Export</p>
            </button>
          </div>
        </>
      ) : (
        <div>
          <h4>No Data To Show</h4>
        </div>
      )}
    </div>
  );
}
